import { render, staticRenderFns } from "./CodCollection.vue?vue&type=template&id=74efb441"
import script from "./CodCollection.vue?vue&type=script&lang=js"
export * from "./CodCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports